import { isNumber } from './is-number.js';

/**
 * @description
 * Checks if `value` is `NaN`.
 *
 * @example
 * ``` ts
 * isNaN(NaN);
 * // => true
 * isNaN(new Number(NaN));
 * // => true
 * isNaN(undefined);
 * // => false
 * isNaN('1111');
 * // => false
 * ```
 *
 * @note
 * This method is based on Number.isNaN and is not the same as global isNaN which returns true for undefined and other non-number values.
 *
 *
 * @param value The value to check.
 * @returns Returns `true` if value is `NaN`, else `false`.
 *
 * @docsCategory preference/lang
 * @codeFilter is-nan
 */
export const isNaN = (value): value is File => {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
};
